import storage from '@/services/storage.js'
import {
    createRouter,
    createWebHistory
} from 'vue-router'

import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import Profilo from "@/views/Profilo.vue"
import Clienti from "@/views/Clienti.vue"
import Importi from "@/views/Importi.vue"
import Zone from "@/views/Zone.vue"

const routes = [{
    path: "/",
    meta: {
        auth: true
    },
    component: Main,

    children: [
        {
            path: "/clienti",
            component: Clienti,
        },
        {
            path: "/importi",
            component: Importi,
        },
        {
            path: "/zone",
            component: Zone,
        },
        {
            // Profilo personale: nessun vincolo di ruolo, ogni utente autenticato
            // gestisce i propri dati/password.
            path: "/profilo",
            component: Profilo,
        },
        {
            path: "/:catchAll(.*)",
            component: Home,
        },
        {
            path: "/",
            meta: {
                auth: true
            },
            component: Home,
        },
    ]
}, {
    path: "/login",
    name: "LoginPage",
    component: Login,
}]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {

    if (to.path == "/@esci") storage.logout();

    // Controllo se è richiesta l'autenticazione. Se la destinazione non è la
    // home, la memorizzo in query così dopo il login si torna lì.
    if (to.path != "/login" && to.meta.auth && !storage.checkAuth()) {
        next({
            path: '/login',
            query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
        })
        return
    }
    // Controllo pagina login
    else if (to.path == "/login" && storage.checkAuth()) {

        // Se il login è stato fatto, vado alla pagina riservata
        next({
            path: '/'
        })

        return
    }

    // Controllo ruoli (RBAC lato frontend: usabilità, non è la vera barriera
    // di sicurezza, che resta il backend con [Authorize(Roles=...)])
    if (to.meta.roles && to.meta.roles.length > 0) {
        const ruolo = storage.getRole ? storage.getRole() : null
        if (ruolo && !to.meta.roles.includes(ruolo)) {
            next({ path: '/' })
            return
        }
    }

    next();

})
export default router
